/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Card, CardBody, Heading, Flex } from "@chakra-ui/react";
import BreadCrumb from "../../components/breadCrumb";
import Loader from "../../components/PageLoader";
import FormInput from "../../components/forms/form-Input";
import { Paths } from "../../routes/paths";
import { useGetNotificationDetail } from "../../services/notifications";

export default function NotificationDetails() {
  const params = useParams();

  const {
    mutate: getNotificationDetail,
    data: detailRes,
    isPending: gettingDetails,
  } = useGetNotificationDetail();
  const { control, reset, watch } = useForm({ defaultValues: {} });

  useEffect(() => {
    if (params.notificationId) {
      getNotificationDetail(params.notificationId);
    }
  }, []);

  useEffect(() => {
    if (detailRes) {
      const _res = detailRes.data;
      reset({ ..._res });
    }
  }, [detailRes]);

  const generalFieldProps = { control };

  return (
    <>
      {gettingDetails ? <Loader /> : null}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Notifications", link: Paths.notification },
            { text: "Notification Details", isCurrentPage: true },
          ]}
        />
        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Flex w="100%" justify="space-between">
                <Heading>Notification Details</Heading>
                <Button
                  as={Link}
                  to={`${Paths.editNotification}/${params.id || watch("id")}`}
                >
                  Edit Notification
                </Button>
              </Flex>

              <form className="add-notification-form">
                <FormInput
                  {...generalFieldProps}
                  label="Description"
                  name="description"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Event Category"
                  name="eventCategory"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Event Type"
                  name="eventType"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Notification Type"
                  name="notificationType"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Threshold Type"
                  name="thresholdType"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Threshold"
                  name="threshold"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="When Sent"
                  name="whenSent"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Escalation Level"
                  name="escalationLevel"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Assignment Group"
                  name="assignmentGroup"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Activities"
                  name="activities"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Customers"
                  name="customers"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Regions"
                  name="regions"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Notification Channels"
                  name="notificationChannels"
                  inputProps={{ readOnly: true }}
                />
                <FormInput
                  {...generalFieldProps}
                  label="Status"
                  name="isActive"
                  inputProps={{ readOnly: true }}
                />
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
